import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/HomePage/avatar.jpg'


const _hoisted_1 = { class: "home-page" }
const _hoisted_2 = { class: "home-content" }
const _hoisted_3 = { class: "welcome" }
const _hoisted_4 = { class: "categories" }
const _hoisted_5 = { class: "card-grid" }
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 0,
  class: "card-previews",
  "aria-hidden": "true"
}
const _hoisted_8 = ["src", "onError"]
const _hoisted_9 = {
  class: "card-icon",
  "aria-hidden": "true"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "card-content" }
const _hoisted_13 = { class: "card-heading" }
const _hoisted_14 = {
  key: 0,
  class: "card-badge"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 0,
  class: "acknowledgements-card",
  "aria-labelledby": "acknowledgements-title"
}
const _hoisted_18 = { class: "acknowledgements-heading" }
const _hoisted_19 = { id: "acknowledgements-title" }
const _hoisted_20 = { class: "acknowledgements-list" }
const _hoisted_21 = ["href"]
const _hoisted_22 = {
  key: 1,
  class: "acknowledgements-name"
}
const _hoisted_23 = { key: 2 }
const _hoisted_24 = {
  key: 0,
  class: "contact-section",
  "aria-labelledby": "contact-title"
}
const _hoisted_25 = { id: "contact-title" }
const _hoisted_26 = { class: "contact-links" }
const _hoisted_27 = ["href", "aria-label"]
const _hoisted_28 = { class: "contact-platform" }
const _hoisted_29 = ["src"]

import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { contactLinks } from "@/configs/contactLinks";
import homePageData from "@/configs/homePage.json";

interface HomeCard {
  id: string;
  href: string;
  title: string;
  titleKey?: string;
  description: string;
  descriptionKey?: string;
  icon: string;
  cover?: string;
  previewImages?: string[];
  credit?: string;
  badge?: string;
  badgeKey?: string;
}
interface HomeCategory {
  id: string;
  title: string;
  titleKey: string;
  color: string;
  background: string;
  cards: HomeCard[];
}
interface HomeAcknowledgement {
  id: string;
  name: string;
  description: string;
  href?: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const categories: HomeCategory[] = homePageData.categories;
const acknowledgements: HomeAcknowledgement[] = homePageData.acknowledgements;
const { t, te } = useI18n({ useScope: "global" });
const displayText = (value: string, key?: string) => key && te(key) ? t(key) : value;
const failedPreviewImages = ref(new Set<string>());
const cardPreviews = (card: HomeCard) => (card.previewImages ?? [])
  .map(src => src.trim())
  .filter(src => src && !failedPreviewImages.value.has(src))
  .slice(0, 3);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("img", {
          class: "avatar",
          alt: "",
          src: _imports_0
        }, null, -1)),
        _createElementVNode("div", null, [
          _createElementVNode("h1", null, _toDisplayString(_unref(t)('homePage.ui.welcome')), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(t)('homePage.ui.subtitle')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (category) => {
          return (_openBlock(), _createElementBlock("fieldset", {
            key: category.id,
            class: "category",
            style: _normalizeStyle({ '--category-color': category.color, '--category-background': category.background })
          }, [
            _createElementVNode("legend", null, [
              _createElementVNode("h2", null, [
                _createTextVNode(_toDisplayString(displayText(category.title, category.titleKey)) + " ", 1),
                _createElementVNode("span", null, "· " + _toDisplayString(category.cards.length), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.cards, (card) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: card.id,
                  class: "tool-card",
                  href: card.href
                }, [
                  (cardPreviews(card).length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cardPreviews(card), (preview, index) => {
                          return (_openBlock(), _createElementBlock("img", {
                            key: `${index}:${preview}`,
                            class: "card-preview-image",
                            src: preview,
                            alt: "",
                            loading: "lazy",
                            decoding: "async",
                            onError: ($event: any) => (failedPreviewImages.value.add(preview))
                          }, null, 40, _hoisted_8))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_9, [
                    (card.cover)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: card.cover,
                          alt: "",
                          loading: "lazy"
                        }, null, 8, _hoisted_10))
                      : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(card.icon), 1))
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("h3", null, _toDisplayString(displayText(card.title, card.titleKey)), 1),
                      (card.badge?.trim())
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(displayText(card.badge, card.badgeKey)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (card.description)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(displayText(card.description, card.descriptionKey)), 1))
                      : _createCommentVNode("", true),
                    (card.credit)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_16, _toDisplayString(card.credit), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _cache[1] || (_cache[1] = _createElementVNode("span", {
                    class: "card-arrow",
                    "aria-hidden": "true"
                  }, "›", -1))
                ], 8, _hoisted_6))
              }), 128))
            ])
          ], 4))
        }), 128)),
        (_unref(acknowledgements).length)
          ? (_openBlock(), _createElementBlock("details", _hoisted_17, [
              _createElementVNode("summary", _hoisted_18, [
                _cache[2] || (_cache[2] = _createElementVNode("span", {
                  class: "acknowledgements-icon",
                  "aria-hidden": "true"
                }, "♡", -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("h2", _hoisted_19, _toDisplayString(_unref(t)('homePage.acknowledgements.title')), 1),
                  _createElementVNode("p", null, _toDisplayString(_unref(t)('homePage.acknowledgements.description')), 1)
                ]),
                _cache[3] || (_cache[3] = _createElementVNode("span", {
                  class: "acknowledgements-chevron",
                  "aria-hidden": "true"
                }, null, -1))
              ]),
              _createElementVNode("ul", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(acknowledgements), (acknowledgement) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: acknowledgement.id
                  }, [
                    (acknowledgement.href)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: acknowledgement.href,
                          target: "_blank",
                          rel: "noopener noreferrer"
                        }, _toDisplayString(acknowledgement.name), 9, _hoisted_21))
                      : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(acknowledgement.name), 1)),
                    (acknowledgement.description)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(acknowledgement.description), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_unref(contactLinks).length)
        ? (_openBlock(), _createElementBlock("section", _hoisted_24, [
            _createElementVNode("h2", _hoisted_25, _toDisplayString(_unref(t)('homePage.ui.contactTitle')), 1),
            _createElementVNode("div", _hoisted_26, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contactLinks), (contact) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: contact.href,
                  class: "contact-badge",
                  href: contact.href,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  "aria-label": `${contact.platform}: ${contact.label}`
                }, [
                  _createElementVNode("span", _hoisted_28, [
                    _createElementVNode("img", {
                      src: contact.image,
                      alt: "",
                      width: "16",
                      height: "16",
                      loading: "lazy"
                    }, null, 8, _hoisted_29),
                    _createTextVNode(" " + _toDisplayString(contact.platform), 1)
                  ]),
                  _createElementVNode("span", {
                    class: "contact-label",
                    style: _normalizeStyle({ backgroundColor: contact.color })
                  }, _toDisplayString(contact.label), 5)
                ], 8, _hoisted_27))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})